export const ROUTES = {
    AccessibilityStatement: 'accessibilityStatement',
    Recognition: './recognition',
    Search: '/search',
    Favourites: 'favourites',
    InHouseBenefits: '/inHouseBenefits',
    Home: '/home',
    Orders: '/orders',
    Goals: '/goals',
    Profile: '/profile',
    Resource: '/resource',
}
